import { useEffect, useState } from 'react';
import { now } from './clock';

/** Current (demo-aware) time, refreshed every `intervalMs`. */
export function useNow(intervalMs = 30000): number {
  const [t, setT] = useState(now);
  useEffect(() => {
    const id = setInterval(() => setT(now()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  return t;
}
